export const WAF_ERROR_MESSAGES = {
  CHALLENGE: 'AWS WAF Challenge',
  CAPTCHA: 'AWS WAF Recaptcha',
  FORBIDDEN: 'AWS WAF Forbidden',
  LOAD: 'AWS Load Error',
};

export const CAPTCHA_URL = 'https://aa91ab2ba082.edge.captcha-sdk.awswaf.com/aa91ab2ba082/jsapi.js';

export const CHALLENGE_URL = 'https://aa91ab2ba082.edge.sdk.awswaf.com/aa91ab2ba082/e11ca6561b96/challenge.js';
